import {FREE} from './Types'
export const free = (data=false,type=FREE) => dispatch => {
    dispatch({
        type:type,
        payload:data
    })
}